export const navbarLinks: { title: string; to: string }[] = [
    { title: 'About', to: '/' },
    { title: 'Skills', to: '/?section=skills' },
    { title: 'Personal skills', to: '/?section=personal' },
    { title: 'Life', to: '/life' },
    { title: 'Testimonials', to: '/?section=testimonials' },
    { title: 'Portfolio', to: '/?section=portfolio' },
    { title: 'Contact', to: '/?section=contact' },
]
